import { render, staticRenderFns } from "./NameWithIconSelect.vue?vue&type=template&id=1d25a463&"
import script from "./NameWithIconSelect.vue?vue&type=script&lang=js&"
export * from "./NameWithIconSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports